import { Check } from 'lucide-react';
import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import s from './Stepper.module.css';

/** Numbered blue circle markers — the books' screenshot callouts, used for steps. */
export function Stepper({ steps, current, className }: { steps: { label: ReactNode; description?: ReactNode }[]; current: number; className?: string }) {
  return (
    <ol className={cx(s.stepper, className)}>
      {steps.map((step, i) => {
        const state = i < current ? 'done' : i === current ? 'current' : 'todo';
        return (
          <li key={i} className={cx(s.step, s[state])} aria-current={state === 'current' ? 'step' : undefined}>
            <span className={s.marker}>{state === 'done' ? <Check aria-hidden /> : i + 1}</span>
            <span className={s.stepText}>
              <span className={s.stepLabel}>{step.label}</span>
              {step.description && <span className={s.stepDescription}>{step.description}</span>}
            </span>
          </li>
        );
      })}
    </ol>
  );
}

/** A single numbered marker, for tying annotations to explanations. */
export function Marker({ n }: { n: number }) {
  return <span className={s.marker}>{n}</span>;
}
